(() => {
  if (window.mamMarketHomeBound) return;
  window.mamMarketHomeBound = true;
  const wishlistKey = 'mam_market_wishlist_v1';
  let savedProducts = new Set();
  let storageAvailable = false;
  try {
    const stored = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
    if (Array.isArray(stored)) savedProducts = new Set(stored.filter((value) => typeof value === 'string'));
    localStorage.setItem(wishlistKey, JSON.stringify([...savedProducts]));
    storageAvailable = true;
  } catch (_) {}

  function syncWishlist() {
    document.querySelectorAll('.mm-home [data-mm-wishlist]').forEach((button) => {
      const saved = savedProducts.has(button.dataset.productId);
      button.hidden = !storageAvailable;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? button.dataset.removeLabel : button.dataset.addLabel);
    });
  }

  function updateVariant(select) {
    const card = select.closest('[data-mm-product]');
    const option = select.selectedOptions[0];
    if (!card || !option) return;
    card.querySelector('[data-mm-price]').textContent = option.dataset.price;
    const compare = card.querySelector('[data-mm-compare]');
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
    const badge = card.querySelector('[data-mm-discount]');
    const discount = Number(option.dataset.discount) || 0;
    badge.hidden = discount <= 0;
    badge.textContent = card.dataset.discountLabel.replace('__percent__', String(discount));
    const addButton = card.querySelector('[data-mm-add]');
    const available = option.dataset.available === 'true';
    addButton.disabled = !available;
    addButton.textContent = available ? card.dataset.addLabel : card.dataset.soldLabel;
    card.querySelectorAll('[data-mm-product-link]').forEach((link) => { link.href = option.dataset.url; });
    const image = card.querySelector('.mm-product__image');
    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.removeAttribute('srcset');
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const wishlist = event.target.closest('[data-mm-wishlist]');
    if (wishlist && wishlist.closest('.mm-home') && storageAvailable) {
      const next = new Set(savedProducts);
      const productId = wishlist.dataset.productId;
      if (next.has(productId)) next.delete(productId);
      else next.add(productId);
      try {
        localStorage.setItem(wishlistKey, JSON.stringify([...next]));
        savedProducts = next;
      } catch (_) {
        storageAvailable = false;
      }
      syncWishlist();
      return;
    }
    const button = event.target.closest('[data-mm-scroll]');
    if (!button || !button.closest('.mm-home')) return;
    const track = document.getElementById(button.getAttribute('aria-controls'));
    if (!track) return;
    track.scrollBy({ left: track.clientWidth * 0.85 * Number(button.dataset.mmScroll), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLSelectElement && event.target.matches('.mm-home [data-mm-variant]')) updateVariant(event.target);
  });
  document.addEventListener('shopify:section:load', syncWishlist);
  window.addEventListener('storage', (event) => {
    if (event.key !== wishlistKey) return;
    try {
      const stored = JSON.parse(event.newValue || '[]');
      savedProducts = new Set(Array.isArray(stored) ? stored.filter((value) => typeof value === 'string') : []);
      syncWishlist();
    } catch (_) {}
  });
  syncWishlist();
})();

